var ifAriaNoLabel = function (ariaLabel) { return !!ariaLabel || ariaLabel === ''; };
export var ariaLabelOrHidden = function (ariaLabel) {
    return ifAriaNoLabel(ariaLabel)
        ? { 'aria-label': ariaLabel, role: 'img' }
        : { 'aria-hidden': true };
};
export var ariaFocusableNoLabel = function (ariaLabel) {
    return ifAriaNoLabel(ariaLabel) ? {} : { focusable: false };
};
//# sourceMappingURL=aria.js.map